import { useRef, useState } from "react";
import ButtonMui from "@mui/material/Button";
import { LuSave } from "react-icons/lu";
// API
import { newUser, saveClientDetails } from "../../../../../api/clients";
const Input=({id,label,description,defaultValue="",disabled=false})=><div className="sa-field"><label htmlFor={id}>{label}</label><input id={id} aria-describedby={`${id}-help`} type={/email|Mail/.test(id)?'email':'text'} defaultValue={defaultValue??''} disabled={disabled}/><small id={`${id}-help`}>{description}</small></div>;

export const ClientDetails = ({ data, isEmpty, queryId, clientData, closeFloatPanel }) => {
  const pending = useRef(false);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const handleNewUser = async () => {
    if(pending.current)return;pending.current=true;setSaving(true);setFeedback(null);
    try {
    const payload = {
      email: document.getElementById("email").value,
      subdomain: document.getElementById("subdomain").value,
      fullname: document.getElementById("fullname").value,
      phone: document.getElementById("phone").value,
      nif: document.getElementById("nif").value,
      corpName: document.getElementById("corpName").value,
      corpNif: document.getElementById("corpNif").value,
      corpMail: document.getElementById("corpMail").value,
      corpPhone: document.getElementById("corpPhone").value,
      activeKitchen: data?.corporationData?.subdomain ? document.getElementById("domain-order").checked : true,
      activeTpv: data?.corporationData?.subdomain ? document.getElementById("domain-delivery").checked : true,
      activeDelivery: data?.corporationData?.subdomain ? document.getElementById("domain-delivery").checked : true,
      activeShop: data?.corporationData?.subdomain ? document.getElementById("domain-shop").checked : true,
    };

    const response = await newUser(payload);
    if (response === false) { pending.current=false; setSaving(false); closeFloatPanel(true); }
    else setFeedback({ok:false,text:"No se pudo crear el cliente. Revisa los datos y vuelve a intentarlo."});
    } catch { setFeedback({ok:false,text:"No se pudo crear el cliente. Comprueba la conexión."}); }
    finally {pending.current=false;setSaving(false);}
  };

  const handleDetails = async () => {
    if (pending.current) return;
    pending.current = true;
    setSaving(true);
    setFeedback(null);
    const payload = {
      email: document.getElementById("email").value,
      subdomain: document.getElementById("subdomain").value,
      fullname: document.getElementById("fullname").value,
      phone: document.getElementById("phone").value,
      nif: document.getElementById("nif").value,
      corpName: document.getElementById("corpName").value,
      corpNif: document.getElementById("corpNif").value,
      corpMail: document.getElementById("corpMail").value,
      corpPhone: document.getElementById("corpPhone").value,
    };

    try {
      const response = await saveClientDetails(queryId, {
        ...payload, ownerId: clientData.userId,
      });
      setFeedback(response?.error === false
        ? { ok: true, text: "Datos del cliente guardados." }
        : { ok: false, text: "No se han podido guardar los datos. Revisa email, NIF y teléfono; puedes corregirlos y volver a intentarlo." });
    } catch {
      setFeedback({ ok: false, text: "No se han podido guardar los datos. Vuelve a intentarlo." });
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };

  return (
    <div className="row gap-2 pt-2 sa-client-fields" data-write-pending={saving} onChange={() => setFeedback(null)}>
      <div className="col-12 text-align-right" style={{ marginTop: "-25px" }}>
        <ButtonMui className="customButton customButtonColor1" variant="contained" onClick={isEmpty?handleNewUser:handleDetails} disabled={saving} aria-busy={saving}>
            <LuSave aria-hidden="true" />{saving ? "Guardando…" : isEmpty ? "Crear cliente" : "Guardar cambios"}
          </ButtonMui>
        {feedback && <p role={feedback.ok ? "status" : "alert"}>{feedback.text}</p>}
      </div>
      <div className="col-12">
        <div className="row">
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"fullname"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Nombre del propietario"
              description="Escriba el nombre del cliente"
              defaultValue={isEmpty ? "" : data.owners[0].fullname}
            />
          </div>
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"nif"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="NIF"
              description="Escriba el número de identificador fiscal"
              validation="dni"
              defaultValue={isEmpty ? "" : data.owners[0].nif}
            />
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="row">
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"email"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Email"
              description="Escriba el email"
              defaultValue={isEmpty ? "" : data.owners[0].email}
              validation="email"
            />
          </div>
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"phone"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Teléfono"
              description="Escriba el número de teléfono"
              defaultValue={isEmpty ? "" : data.owners[0].phone}
              validation="telefono"
            />
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="row">
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"corpName"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Razón social"
              description="Escriba la razón social"
              defaultValue={isEmpty ? "" : data.corporationData.legalName ?? ""}
            />
          </div>
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"corpNif"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="NIF Empresa"
              description="Escriba el número de identificador fiscal de la empresa"
              validation="dni"
              defaultValue={isEmpty ? "" : data.corporationData.nif}
            />
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="row">
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"corpMail"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Email empresa"
              description="Escriba el email de empresa"
              defaultValue={isEmpty ? "" : data.corporationData.email}
              validation="email"
            />
          </div>
          <div className="col-md-6 col-12">
            <Input
              disabled={saving}
              id={"corpPhone"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Teléfono empresa"
              description="Escriba el teléfono de la empresa"
              validation="telefono"
              defaultValue={isEmpty ? "" : data.corporationData.phone}
            />
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="row">
          <div className="col">
            <Input
              id={"subdomain"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Identificador URL del negocio"
              description="Escriba el identificador de la URL, no se podrá modificar"
              defaultValue={isEmpty ? "" : data.corporationData.subdomain}
              disabled={saving || (!isEmpty && data.corporationData?.subdomain && data.corporationData?.subdomain !== "")}
              validation="url"
              /*onChange={handleUrl}*/
            />
          </div>
        </div>
      </div>
    </div>
  );
};
